<template>
  <div class="board-content-view-wrap">
    <div class="sticky-area" v-if="device === 'mobile'">
      <common-header title="당첨자 발표" :is-back-btn="true" :back-fn="close" :is-close-btn="true" :close-fn="close"></common-header>
    </div>
    <div v-if="boardContentData" class="event-view-wrap">
      <div class="event-view-tit component-line">
        <strong class="event-tit">{{boardContentData.eventtitle}}</strong>
        <p class="event-text">{{boardContentData.announcementdate}}</p>
      </div>

      <div class="event-winner-wrap" v-html="boardContentData.content"></div>
    </div>
  </div>
</template>

<script>
import { EventService } from '@/common/api/api.service'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import CommonHeader from '@/components/header/template/commonHeader'
export default {
  name: 'BoardContent',
  components: {
    CommonHeader
  },
  data () {
    return {
      boardContentData: undefined,
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    close () {
      this.$router.back()
    }
  },
  created () {
    EventService.getEventNoticeContent({ eventid: this.$route.params.eventid })
      .then(({ data }) => {
        data.content = get(data, 'content', '')
          .replace(/\\r\\n/g, '<br />')
          .replace(/\\\\n/g, '<br />')
          .replace(/\\n/g, '<br />')
        this.boardContentData = data
      })
  }

}
</script>

<style scoped>
.board-content-view-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 3000;
}

.event-winner-wrap {
  white-space:pre-line;
  font-size: 13px;
  color: #a5a5a5;
  padding: 15px 0 15px 0;
  width: 100%;
  height: auto;
}

.event-view-wrap {
  padding: 0 10px 0 10px;
  position: relative;
  width: 100%;
  /*overflow-y:scroll;*/
  /*overflow-scrolling: touch;*/
  /*-webkit-overflow-scrolling: touch;*/
}
 .event-view-wrap::-webkit-scrollbar {
   display: none;
   background-color: transparent
 }
.event-view-tit {
  padding: 17px 0;
}
.component-line {
  border-bottom: 1px solid #2f2f2f;
}
.event-view-tit .event-tit {
  padding: 0 0 5px;
}

.event-tit, .event-tit02 {
  display: block;
  color: #fff;
}
.event-tit {
  padding: 15px 10px 10px;
  font-size: 16px;
}
h1, h2, h3, h4, h5, h6, strong {
  font-weight: 400;
}
.event-view-tit .event-text {
  padding: 0;
}

.event-text {
  font-size: 12px;
  color: #717171;
  padding: 0 10px 3px;
}
</style>
